import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function Webhooks() {
  const { api } = useAuth();
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [events, setEvents] = useState([]);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [revealedSecret, setRevealedSecret] = useState(null);

  const load = () => api('/webhooks').then(setItems).catch(() => {});
  useEffect(() => { load(); api('/webhooks/events').then(setEvents).catch(() => {}); }, []); // eslint-disable-line

  const toggleEvent = (e) => setSelectedEvents(prev => prev.includes(e) ? prev.filter(x => x !== e) : [...prev, e]);

  const create = async () => {
    if (!name.trim() || !url.trim() || selectedEvents.length === 0) {
      toast.error('املأ الاسم والرابط واختر حدثاً واحداً على الأقل');
      return;
    }
    try {
      const r = await api('/webhooks', { method: 'POST', body: JSON.stringify({ name, url, events: selectedEvents }) });
      setRevealedSecret({ id: r.webhook.id, secret: r.secret });
      setName(''); setUrl(''); setSelectedEvents([]); load();
      toast.success('تمّ إنشاء Webhook — احفظ المفتاح السرّي قبل الإغلاق');
    } catch (e) { toast.error(e.message); }
  };

  const remove = async (id) => {
    if (!window.confirm('حذف هذا الـ Webhook؟')) return;
    try { await api(`/webhooks/${id}`, { method: 'DELETE' }); load(); } catch (e) { toast.error(e.message); }
  };

  const toggleActive = async (h) => {
    try { await api(`/webhooks/${h.id}`, { method: 'PUT', body: JSON.stringify({ is_active: !h.is_active }) }); load(); }
    catch (e) { toast.error(e.message); }
  };

  const rotate = async (id) => {
    if (!window.confirm('سيُبطَل المفتاح القديم. متابعة؟')) return;
    try {
      const r = await api(`/webhooks/${id}/rotate-secret`, { method: 'POST' });
      setRevealedSecret({ id, secret: r.secret });
      toast.success('تم تجديد المفتاح');
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 20 }}>🔗 Webhooks</h2>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>
        أرسل إشعاراً تلقائياً (POST JSON) إلى رابطك عند اكتمال تفريغ أو اعتماده. التوقيع في الترويسة <code>X-Mufrigh-Signature</code> (HMAC-SHA256).
      </div>
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">Webhook جديد</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 12, marginTop: 12 }}>
          <input className="form-input" placeholder="الاسم" value={name} onChange={e => setName(e.target.value)}/>
          <input className="form-input" placeholder="https://..." value={url} onChange={e => setUrl(e.target.value)} dir="ltr"/>
        </div>
        <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {events.map(ev => (
            <label key={ev} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 16, border: '1px solid var(--border)', cursor: 'pointer', background: selectedEvents.includes(ev) ? 'var(--primary-light)' : 'transparent' }}>
              <input type="checkbox" checked={selectedEvents.includes(ev)} onChange={() => toggleEvent(ev)}/>
              <span style={{ fontFamily: 'monospace', fontSize: 13 }}>{ev}</span>
            </label>
          ))}
        </div>
        <button className="btn btn-primary" style={{ marginTop: 12 }} onClick={create}>إنشاء</button>
      </div>
      {revealedSecret && (
        <div className="card" style={{ marginBottom: 20, background: 'var(--accent-light)', borderColor: 'var(--accent)' }}>
          <div className="card-title">🔑 المفتاح السرّي #{revealedSecret.id}</div>
          <div style={{ fontFamily: 'monospace', fontSize: 14, wordBreak: 'break-all', padding: 8, background: 'var(--surface)', borderRadius: 4, marginTop: 8, direction: 'ltr' }}>{revealedSecret.secret}</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 8 }}>⚠️ لن يظهر مرّة أخرى. احفظه في مكان آمن.</div>
          <button className="btn btn-sm btn-outline" style={{ marginTop: 8 }} onClick={() => setRevealedSecret(null)}>إغلاق</button>
        </div>
      )}
      <div className="card">
        <div className="card-title" style={{ marginBottom: 12 }}>الـ Webhooks المُسجّلة ({items.length})</div>
        {items.length === 0 ? <div className="empty">لا webhooks بعد</div> : items.map(h => (
          <div key={h.id} style={{ padding: 12, border: '1px solid var(--border)', borderRadius: 6, marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 }}>
              <div>
                <div style={{ fontWeight: 600 }}>{h.name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', direction: 'ltr', wordBreak: 'break-all' }}>{h.url}</div>
                <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {(h.events || []).map(ev => (<span key={ev} style={{ fontSize: 11, fontFamily: 'monospace', padding: '1px 8px', borderRadius: 4, background: 'var(--gray-100)' }}>{ev}</span>))}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                <span className={`badge badge-${h.is_active ? 'completed' : 'revision'}`}>{h.is_active ? 'نشط' : 'معطّل'}</span>
                <button className="btn btn-sm btn-outline" onClick={() => toggleActive(h)}>{h.is_active ? '🚫' : '✓'}</button>
                <button className="btn btn-sm btn-outline" onClick={() => rotate(h.id)}>🔑</button>
                <button className="btn btn-sm btn-outline" style={{ color: 'var(--danger)' }} onClick={() => remove(h.id)}>🗑️</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
